import type { FunctionComponent } from "react"

import { clsx } from "clsx"
import Image from "next/image"

import styles from "./Media.module.css"

type MediaImageProps = Parameters<typeof Image>[0] & {
  wrapperClassName?: string
}

export const MediaImage: FunctionComponent<MediaImageProps> = ({
  alt = "",
  className = "",
  src,
  priority = false,
  sizes = "(max-width: 768px) 100vw, (max-width: 1280px) 66vw, 50vw",
  wrapperClassName,
}) => (
  <figure className={clsx(wrapperClassName, styles.imageContainer)}>
    <Image
      alt={alt}
      className={clsx(styles.image, className)}
      src={src}
      priority={priority}
      sizes={sizes}
      /* hq random 16 / 9 size, resize is done after on css side */
      height="540"
      width="960"
    />
  </figure>
)
